import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getSubCollectionId } from 'store/ProductDetails/selectors';

export function FlocktoryCatalogContainerLayout({ subCollectionId, children }) {
  return (
    <div
      className="i-flocktory"
      data-fl-action="track-category-view"
      data-fl-category-id={subCollectionId}
    >
      {children}
    </div>
  );
}

FlocktoryCatalogContainerLayout.propTypes = {
  subCollectionId: PropTypes.number,
  children: PropTypes.any,
};

const mapStateToProps = (state) => ({
  subCollectionId: getSubCollectionId(state),
});

const FlocktoryCatalogContainer = connect(mapStateToProps)(FlocktoryCatalogContainerLayout);
export default FlocktoryCatalogContainer;
